import * as constants from './constants';
import checkStatus from '../../../utils/checkStatus';
import R from 'ramda';
import queryString from 'query-string';
import { getUsers } from '../../actions';
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);

const callApiGet = (url) => {
  return fetch(url, {
    method: 'get',
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
  })
    .then(checkStatus);
};
const callApiPost = (url, body) => {
  return fetch(url, {
    method: 'post',
    body: JSON.stringify(body),
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
  })
    .then(checkStatus);
};
const query = `query getLocations ($companyId: ID!) {
  companyProfile  (id: $companyId){
        locations {
          name
          id
          isMarketingReady
        }
  }
}`;
export const getLocations = () => {
  return dispatch => {
    dispatch({ type: constants.UPDATE_PROPS, payload: { loadingLocations: true } });
    return callApiGet(`/proxy/profile?query=${query}`)
      .then(res => res.json())
      .then(payload => dispatch({ type: constants.LOCATIONS_LOADED, payload }))
      .catch(() => {
        dispatch({ type: constants.UPDATE_PROPS, payload: { loadingLocations: false } });
      });
  };
};
export const updateProps = payload => ({ type: constants.UPDATE_PROPS, payload });
export const clearStore = () => ({ type: constants.CLEAR_STORE });
export const getTemplates = () => {
  return dispatch => {
    dispatch({ type: constants.LOADING_TEMPLATES });
    const qs = queryString.stringify({ additionalProjection: JSON.stringify({ products: 1 }) });
    return callApiGet(`/proxy/contracting/templates?${qs}`)
      .then(res => res.json())
      .then(res => dispatch({ type: constants.TEMPLATES_LOADED, payload: R.merge(res, { loading: false }) })) // res = { templates, templateGroups }
      .catch(() => {
        dispatch({ type: constants.LOADING_TEMPLATES });
        dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Loading Templates Failed' });
      });
  };
};


export function getContractRequestInfo(contractId) {
  return {
    type: constants.GET_CONTRACT_REQUEST_INFO,
    payload: contractId,
  };
}



// WEBPACK FOOTER //
// ./src/app/stores/contracting/supplier-wizard/actions.js